import { render, staticRenderFns } from "./SupportSeniors.vue?vue&type=template&id=9ec4618a&"
import script from "./SupportSeniors.vue?vue&type=script&lang=js&"
export * from "./SupportSeniors.vue?vue&type=script&lang=js&"
import style0 from "./SupportSeniors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports